export default function ItemUsageUI({
  wallet,title,
  usage,
  loading,
  useCase,
  setUseCase,
  toEmail,
  setToEmail,
  from,
  setFrom,
  to,
  setTo,
  load
}) {
  return (
    <div style={styles.wrapper}>
      
    

      {/* Filters */}
      <div style={styles.filterCard}>
        <h3 style={styles.sectionTitle}>{title}</h3>

        <div style={styles.filterRow}>
          <input
            style={styles.input}
            placeholder="Use case"
            value={useCase}
            onChange={e => setUseCase(e.target.value)}
          />

          <input
            style={styles.input}
            placeholder="To email"
            value={toEmail}
            onChange={e => setToEmail(e.target.value)}
          />

          <input
            type="date"
            style={styles.input}
            value={from}
            onChange={e => setFrom(e.target.value)}
          />

          <input
            type="date"
            style={styles.input}
            value={to}
            onChange={e => setTo(e.target.value)}
          />

          <button style={styles.button} onClick={load}>
            Apply Filters
          </button>
        </div>
      </div>

      {/* Table */}
      <div style={styles.tableCard}>
        {loading ? (
          <div style={styles.loading}>Loading...</div>
        ) : (
          <table style={styles.table}>
            <thead>
              <tr>
                <th>Date</th>
                <th>Use case</th>
                <th>To</th>
                <th>Credits</th>
              </tr>
            </thead>
            <tbody>
              {usage?.length ? (
                usage.map(u => (
                  <tr key={u.id}>
                    <td>
                      {new Date(u.createdAt).toLocaleString()}
                    </td>
                    <td>{u.useCase}</td>
                    <td>{u.toEmail}</td>
                    <td style={{ fontWeight: 600 }}>
                      {u.creditsUsed}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" style={styles.noData}>
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
const styles = {
  wrapper: {
    padding: 24,
    background: "#f6f8fb",
    
    fontFamily: "Inter, sans-serif"
  },

  header: {
    marginBottom: 20
  },

  card: {
    display: "flex",
    gap: 20,
    background: "#fff",
    padding: 20,
    borderRadius: 12,
    boxShadow: "0 6px 20px rgba(0,0,0,0.05)",
    marginBottom: 20
  },

  statBox: {
    flex: 1,
    display: "flex",
    flexDirection: "column"
  },

  label: {
    fontSize: 13,
    color: "#888"
  },

  value: {
    fontSize: 24,
    fontWeight: 600
  },

  filterCard: {
    background: "#fff",
    padding: 20,
    borderRadius: 12,
    boxShadow: "0 6px 20px rgba(0,0,0,0.05)",
    marginBottom: 20
  },

  sectionTitle: {
    marginBottom: 15
  },

  filterRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: 12
  },

  input: {
    padding: "10px 12px",
    borderRadius: 8,
    border: "1px solid #ddd",
    fontSize: 14,
    minWidth: 150
  },

  button: {
    padding: "10px 18px",
    borderRadius: 8,
    border: "none",
    background: "#4f46e5",
    color: "#fff",
    fontWeight: 600,
    cursor: "pointer"
  },

  tableCard: {
    background: "#fff",
    padding: 20,
    borderRadius: 12,
    boxShadow: "0 6px 20px rgba(0,0,0,0.05)"
  },

  table: {
    width: "100%",
    borderCollapse: "collapse"
  },

  loading: {
    padding: 20
  },

  noData: {
    textAlign: "center",
    padding: 20,
    color: "#999"
  }
};